/**
 * Category Edit Component
 * Form for editing existing card categories
 */

import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  required,
  useRecordContext,
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { LAYER_CHOICES } from '../constants';

/**
 * Title for the edit page
 */
function CategoryTitle() {
  const record = useRecordContext();
  return <span>Edit Category {record ? `"${record.categoryName}"` : ''}</span>;
}

export function CategoryEdit() {
  return (
    <Edit title={<CategoryTitle />}>
      <SimpleForm>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Typography variant="h6" gutterBottom>Category Details</Typography>

          <TextInput
            source="categoryId"
            label="Category ID"
            disabled
          />

          <TextInput
            source="categoryName"
            label="Category Name"
            validate={required()}
            fullWidth
          />

          <SelectInput
            source="layer"
            label="Layer"
            choices={LAYER_CHOICES}
            disabled
            sx={{ minWidth: 250 }}
          />

          <TextInput
            source="description"
            label="Description"
            multiline
            rows={2}
            fullWidth
          />

          <TextInput
            source="toneGuidance"
            label="Tone Guidance"
            multiline
            rows={3}
            fullWidth
          />

          <NumberInput
            source="sensitivityOrder"
            label="Sensitivity Order"
            helperText="Lower = less sensitive, Higher = more sensitive"
          />
        </Box>
      </SimpleForm>
    </Edit>
  );
}
